import React from "react";
import "../styles/Termsofuse.css";
import { Link } from "react-router-dom";

const Accessibility = () => {
  return (
    <div className="legal-wrapper">
      <main className="legal-main">
        <h1>Accessibility</h1>
        <p className="effective-date">Effective: January 15, 2020</p>
        <p>
          Berymo Places is committed to providing safe rides for everyone and
          transporting individuals with disabilities safely to their destination
          through innovative technologies and solution-oriented customer service.
        </p>
        <p>
          With ride requests at your fingertips, fare transparency, paperless
          payments and our inclusive service animal policy, Berymo Places
          transports its users with security and confidence to the best local
          restaurants.
        </p>
        <p>
          <strong>Request a ride with a tap:</strong> Users with disabilities
          can request unlimited free rides with a tap of a button.
        </p>
        <p>
          <strong>Fare transparency:</strong> Berymo Places will offer unlimited
          free rides to its users and it will always be free. Users will not have
          to worry about getting the fare changed on them unexpectedly.
        </p>
        <p>
          <strong>Service Animals:</strong> Users can add their bank information
          and the transaction will be completed automatically so users don’t have
          to exchange cash with their driver.
        </p>
        <p>
          To report a service animal denial, submit a ticket here.
        </p>
        <p>
          The Berymo Places app offers complete functionality to those with
          hearing or vision impairments. By utilizing audible, tactile and visual
          alerts, users with impairments can easily navigate around the platform
          and their city alike with ease.
        </p>
        <p>
          <strong>Audible:</strong> The Berymo Places App has built-in sounds to
          alert riders of when they have been matched with a driver and when
          their driver has arrived at the confirmed pickup location.
        </p>
        <p>
          <strong>Tactile:</strong> The Berymo Places App vibrates when important
          transportation checkpoints have been reached to provide another level
          of awareness to users.
        </p>
        <p>
          <strong>Visual:</strong> The Berymo Places App offers an easy user
          interface so riders can easily enter their desired pickup and partner
          place locations, track the progress of their trip and much more.
        </p>
        <p>
          Berymo Places is devoted to improving its in-app functions for its
          users and continuing to provide the best possible user experience for
          all.
        </p>
      </main>
      <aside className="legal-sidebar">
        <ul>
          <li>
            <Link to="/Legal">Privacy Policy</Link>
          </li>
          <hr />
          <li>
            <Link to="/TermsofUse">Terms of Use</Link>
          </li>
          <hr />
          <li>
            <Link to="/Accessibility" className="active">
              Accessibility
            </Link>
          </li>
          <hr />
          <li>
            <Link to="/Independent">Independent Contractor Agreement</Link>
          </li>
          <hr />
          <li>
            <Link to="/PartnerPlacesAgreement">Partner Places Agreement</Link>
          </li>
          <hr />
        </ul>
      </aside>
    </div>
  );
};

export default Accessibility;

